import { Injectable } from '@angular/core';
import { BehaviorSubject, debounceTime } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppLoadingService {
  private loadingSubject = new BehaviorSubject(true);
  loading$ = this.loadingSubject.asObservable().pipe(debounceTime(100));

  constructor() { }

  showLoading() {
    this.loadingSubject.next(true);
  }

  hideLoading() {
    this.loadingSubject.next(false);
  }
}
